import React from 'react'
import { Link } from 'react-router-dom'
import { TEST_MODE } from '../config/testMode'

interface User {
  id: string
  email: string
  isPremium: boolean
}

interface HomeProps {
  user?: User | null
  onSignInClick?: () => void
}

const Home: React.FC<HomeProps> = ({ user, onSignInClick }) => {
  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ 
        background: 'white', 
        padding: '2rem', 
        borderRadius: '12px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '2rem'
      }}>
        <h1 style={{ color: '#2d5a27', marginBottom: '1rem' }}>Welcome to Muddy Boots Garden Planner</h1>
        <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
          Plan your garden from 1 square foot to 1 acre. Get personalized planting 
          calendars, companion planting advice, and track your harvest.
        </p>
        
        {user ? (
          <div style={{ 
            background: '#e8f5e9', 
            padding: '1rem', 
            borderRadius: '8px', 
            marginTop: '1rem',
            border: '1px solid #4caf50'
          }}>
            <p><strong>Welcome back, {user.email}!</strong></p>
          </div>
        ) : (
          <div style={{ 
            background: '#fff3e0', 
            padding: '1rem', 
            borderRadius: '8px', 
            marginTop: '1rem',
            border: '1px solid #ff9800'
          }}>
            <p><strong>Please Sign In</strong></p>
            <p style={{ fontSize: '0.9rem' }}>Sign in to create and save your garden designs.</p>
          </div>
        )}
        
        <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          {user ? (
            <Link to="/designer" style={{ textDecoration: 'none' }}>
              <button style={{
                background: '#2d5a27',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '6px',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: 'bold'
              }}>
                Start Designing Your Garden
              </button>
            </Link>
          ) : (
            <button 
              onClick={onSignInClick}
              style={{
                background: '#2d5a27',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '6px',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: 'bold'
              }}
            >
              Start Designing Your Garden
            </button>
          )}
          
          <Link to="/plants" style={{ textDecoration: 'none' }}>
            <button style={{
              background: '#f5f5f5',
              color: '#333',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              border: '1px solid #ddd',
              cursor: 'pointer',
              fontSize: '1rem'
            }}>
              Browse Plants
            </button>
          </Link>
        </div>
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
        gap: '1.5rem' 
      }}>
        <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3 style={{ color: '#2d5a27' }}>🗓️ Smart Calendar</h3>
          <p>Get planting dates based on your zip code and local frost dates.</p>
        </div>
        
        <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3 style={{ color: '#2d5a27' }}>🌿 Companion Planting</h3>
          <p>Know which plants grow well together and which to keep apart.</p>
        </div>
        
        <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3 style={{ color: '#2d5a27' }}>📊 Track Harvests</h3>
          <p>Log your yields and see how much you're growing.</p>
        </div>
        
        <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3 style={{ color: '#2d5a27' }}>📱 Works Everywhere</h3>
          <p>Use on your phone in the garden or desktop at home.</p>
        </div>
      </div>

      <div style={{ 
        background: 'linear-gradient(135deg, #2d5a27, #4a7c43)', 
        color: 'white',
        padding: '2rem', 
        borderRadius: '12px', 
        marginTop: '2rem',
        textAlign: 'center'
      }}>
        <h3>{TEST_MODE.DISABLE_PAYMENTS ? '🧪 Test Mode - All Features Free' : 'Free to Start'}</h3>
        <p style={{ marginBottom: '1rem' }}>
          {TEST_MODE.DISABLE_PAYMENTS 
            ? 'All premium features are unlocked for testing. Create unlimited gardens, access all plants, and use every feature!'
            : 'Create your first garden free. Upgrade to Garden Planner Solo for unlimited gardens, advanced features, and exclusive content from Muddy Boots Ranch.'}
        </p>
        <Link to="/pricing" style={{ textDecoration: 'none' }}>
          <button style={{
            background: 'white',
            color: '#2d5a27',
            padding: '0.75rem 1.5rem',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}>
            {TEST_MODE.DISABLE_PAYMENTS ? 'View Test Mode Info' : 'View Pricing'}
          </button>
        </Link>
      </div>
    </div>
  )
}

export default Home
